import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      scores: [],
      players: [],
      currentRound: '3',
      rounds: ['3','4','5','6','7','8','9','10','J','Q','K','Game Over']
  },
    getters: {
        playerScores(state) {

            if (state.players.length === 0) {
                return []
            }

            let playerScores = []

            state.players.forEach((playerName) => {
                playerScores.push({
                    playerName,
                    playerScore: state.scores.filter((score) => playerName === score.playerName).reduce((sum,{score}) => {
                        return sum + parseInt(score)
                    },0)
                })

            })

            return playerScores.sort((a, b) => parseInt(a.playerScore) - parseInt(b.playerScore))

        },
        players(state) {

            return state.players

        },
        currentRound(state) {
            return state.currentRound
        },
        rawScores(state) {
            return state.scores
        }
    },
  mutations: {

      pushPlayer(state,playerName) {
          state.players.push(playerName)
      },
      reset(state) {

          state.scores = []
          state.players = []
          state.currentRound = '3'

      },
      resetGame(state) {

          state.scores = []
          state.currentRound = '3'

      },
      nextRound(state) {

          let thisRoundIndex = state.rounds.findIndex((round) => (round.toString() === state.currentRound))

          state.currentRound = state.rounds[thisRoundIndex + 1]
          if (state.currentRound === 'F') {
              state.currentRound = 3
          }

      },
      pushScore(state,{playerName,score}) {

          state.scores.push({
              playerName,
              round: state.currentRound,
              score
          })

      }

  },
  actions: {
      addPlayer({commit},playerName) {

          commit('pushPlayer',playerName)

      },
      reset({commit}) {

          commit('reset')

      },
      resetGame({commit}) {

          commit('resetGame')

      },
      nextRound({commit}) {

          commit('nextRound')

      },
      addScore({commit},{playerName,score}) {

          commit('pushScore',{playerName,score})

      }
  }
})
